import {ApolloClient, InMemoryCache, createHttpLink, ApolloLink} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import fetch from 'cross-fetch';

import {getMandarkURL} from '@albert-io/environment';

import {BUILD_HEADER} from 'resources/mandark.resource';

import introspection from 'gql/possibleTypes';
import errorLink from './errorLink';

const httpLink = createHttpLink({
  fetch,
  uri: (op) => `${getMandarkURL()}/graphql/query?operation=${encodeURIComponent(op.operationName)}`,
  // https://www.apollographql.com/docs/react/networking/authentication#cookie
  credentials: 'include'
});

const authLink = setContext((_, {headers}) => {
  return {
    headers: {
      ...headers,
      ...BUILD_HEADER()
    }
  };
});

const cache = new InMemoryCache({
  possibleTypes: introspection.possibleTypes,
  typePolicies: {
    /*
     * disable normalization for GuideLevelSearchResult because the same id can have
     * different `children` depending on the search query — caching this leads to stale results
     * ex:
     * - searching for "15.6.13" might return a result with 1 child.
     * - searching for "15.6.1" might return the same `id` but with 3 children.
     * - searching again for "15.6.13" will return the same `id` but with 3 children now (stale)
     */
    GuideLevelSearchResult: {
      keyFields: false
    }
  }
});

const link = ApolloLink.from([errorLink, authLink, httpLink]);

const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: process.env.NODE_ENV === 'development'
});

export default client;
